export const routeGroups = {
    taxonomy: 'taxonomy',
    levelOne: 'levelOne',
    levelTwo: 'levelTwo',
    features: 'features',
    options: 'options',
    colors: 'colors',
    trims: 'trims',
    location:'location'
};
